import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";

import { getAuthorizationToken } from "@/auth/tokenStore";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
// import TabsClientNew from "../Components/new-client-dashboard/NewTabs";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import { fetchPageObject, fetchShakespeareStatus, getCaseId, getClientId } from "../Utils/helper";
import Footer from "../Components/common/footer";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import DatesIcon from "../assets/images/dates.svg";
import DetailIcon from "../assets/images/detail.svg";
import SimpleIcon from "../assets/images/simple-icon.svg";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
// import AddDefendant from "../Components/DefendantPage/DefandantMain/AddDefendant";
import DefendantsDetailView from "../Components/DefendantPage/DefendantsDetailView ";
import { fetchCreateInsuranceModalData } from "../Redux/insurance/insuranceSlice";
import DefendantsSummaryView from "../Components/DefendantPage/DefendantsSummaryView";
import DefendantsSimpleView from "../Components/DefendantPage/DefendantsSimpleView";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import addIconGold from "../assets/Add-icon-gold.svg";
import PlaceHolderifNothingAdded from "../Components/components-new-final/placeholder-nothing-added";
import AddDefendantModal from "../Components/DefendantPage/DefandantMain/modals/AddDefendantModal";
import expandedIcon from "../assets/expand.svg";
import DefendantDetailNewView from "../Components/DefendantPage/DefendantDetailNewView";
import PageDocsTab from "../Components/DocPage/new-tab/page-docs-tab";
import "./DefendantPage.css";
// const PHOTO_ICON_URL =
//   "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg";

const PageContent = ({
  currentPage,
  defendants,
  viewType,
  setIsFetchDefendants,
  isFetchDefendants,
  handleFetchDefendants,
  defendantsLength,
  medicalBillData,
  pageName,
  pageIcon,
}) => {
  // Filter defendants based on current page
  const getFilteredDefendants = () => {
    if (currentPage === "all") {
      return defendants;
    }

    // Check if currentPage matches a specific defendant ID
    if (currentPage?.startsWith("defendant_")) {
      const defendantId = parseInt(currentPage.replace("defendant_", ""));
      return defendants?.filter((defendant) => defendant?.id === defendantId);
    }

    return defendants;
  };

  const filteredDefendants = getFilteredDefendants();
  switch (currentPage) {
    case "photo":
      return <PhotoTab pageId={4} pageName={"Defendant"} />;
    case "docs":
      return <PageDocsTab pageId={4} pageName={pageName} pageIcon={pageIcon} />;
    default:
      if (viewType === "summary") {
        return (
          <DefendantsSummaryView
            defendants={filteredDefendants}
            setIsFetchDefendants={setIsFetchDefendants}
            handleFetchDefendants={handleFetchDefendants}
          />
        );
      } else if (viewType === "simple") {
        return (
          <DefendantsSimpleView
            defendants={filteredDefendants}
            handleFetchDefendants={handleFetchDefendants}
            setIsFetchDefendants={setIsFetchDefendants}
            isFetchDefendants={isFetchDefendants}
            defendantsLength={defendantsLength}
            medicalBillData={medicalBillData}
          />
        );
      } else if (viewType === "expanded") {
        return (
          <DefendantsDetailView
            defendants={filteredDefendants}
            handleFetchDefendants={handleFetchDefendants}
            setIsFetchDefendants={setIsFetchDefendants}
            isFetchDefendants={isFetchDefendants}
            defendantsLength={defendantsLength}
            medicalBillData={medicalBillData}
          />
        );
      } else {
        return (
          <DefendantDetailNewView
            defendants={filteredDefendants}
            handleFetchDefendants={handleFetchDefendants}
            setIsFetchDefendants={setIsFetchDefendants}
            isFetchDefendants={isFetchDefendants}
            defendantsLength={defendantsLength}
            medicalBillData={medicalBillData}
          />
        );
      }
  }
};

function DefendantPage() {
  //
  const dispatch = useDispatch();
  const tokenBearer = getAuthorizationToken();
  const origin = process.env.REACT_APP_BACKEND_URL;
  // const client = useSelector((state) => state.todos.client);
  // const currentCase = useSelector((state) => state.todos.currentCase);
  // console.log(currentCase);
  const currentCaseId = getCaseId();
  const clientId = getClientId();
  const [isFetchDefendants, setIsFetchDefendants] = useState(false);
  const [medicalBillData, setMedicalBillData] = useState({});
  const [currentPage, setCurrentPage] = useState("all");
  const [defendants, setDefendants] = useState([]);
  const [isDummy, setIsDummy] = useState(false);
  const [viewType, setViewType] = useState("summary");
  const [show, setShow] = useState(false);

  const [defendantsLength, setDefendantsLength] = useState(0); //

  const [hasAnyDefendants, setHasAnyDefendants] = useState(0);
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 4).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  useEffect(() => {
    setHasAnyDefendants(defendantsLength);
    if (defendantsLength) {
      setCurrentPage("all");
    }
  }, [defendantsLength]);

  const fecthDefendants = async () => {
    try {
      setIsFetchDefendants(false);
      dispatch(
        fetchCreateInsuranceModalData({
          client_id: clientId,
          case_id: currentCaseId,
        })
      );
      const response = await axios.get(
        `${origin}/api/defendants/defendants_list/${clientId}/${currentCaseId}/`,
        {
          headers: {
            Authorization: tokenBearer,
          },
        }
      );

      const response1 = await axios.get(
        `${origin}/api/settlement-page/lien-information/?case_id=${currentCaseId}&client_id=${clientId}`,
        {
          headers: {
            Authorization: tokenBearer,
          },
        }
      );

      if (response1.status === 200) setMedicalBillData(response1?.data?.data);
      if (response.status === 200) {
        setDefendants(response.data.defendants);
        setDefendantsLength(response?.data?.defendants.length);
      }
    } catch (error) {
      console.error("Error fetching defendants:", error);
    }
  };

  const fecthDummyStatus = async () => {
    try {
      const response = await axios.get(
        `${origin}/api/general/panel_page_block/?case_id=${currentCaseId}&page_id=${4}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: tokenBearer,
          },
        }
      );
      setIsDummy(response?.data?.status);
    } catch (error) {
      console.error("Error fetching dummy status:", error);
    }
  };

  useEffect(() => {
    fecthDummyStatus();
    fecthDefendants();
    fetchShakespeareStatus(currentCaseId, 4, dispatch);
  }, [isFetchDefendants, currentCaseId, dispatch]);

  //   const blockedExpert = useMemo(() => {
  //     return defendants?.find((expert) => expert?.is_blocked === true);
  //   }, [defendants]);

  //   const hasBlockedExpert = useMemo(() => {
  //     return !!blockedExpert;
  //   }, [blockedExpert, defendants]);

  const handleFetchDefendants = () => {
    setIsFetchDefendants(true);
  };

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const handleViewChange = useCallback((nextViewType) => {
    setViewType(nextViewType);
    setCurrentPage((pageType) =>
      nextViewType === "summary" || pageType === "docs" || pageType === "photo" ? "all" : pageType
    );
  }, []);

  const handleCloseAddModal = () => {
    setShow(false);
  };

  // Main tabs: All, Plaintiff, Defendants
  const mainTabs = useMemo(() => {
    const tabs = [];
    //
    tabs.push({
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("all"),
      leftHand: false,
    });
    if (hasAnyDefendants && !isDummy) {
      // Add "All" tab

      // Add individual defendant tabs
      defendants?.forEach((defendant) => {
        let label = "";
        if (defendant?.defendantType === 1) {
          // Private individual - "Last Name, First Name"
          const lastName = defendant?.last_name || "";
          const midInitial = defendant?.middle_name
            ? `${defendant.middle_name.charAt(0).toUpperCase()}.`
            : "";
          const firstName = defendant?.first_name || "";
          label =
            lastName && firstName
              ? `${defendant?.defendantType_name} - ${lastName}, ${firstName} ${midInitial}`
              : lastName
                ? `${defendant?.defendantType_name} - ${lastName}`
                : `${defendant?.defendantType_name} - ${firstName}`;
        } else if (defendant?.defendantType === 2) {
          // Commercial (2) or Public (3) entity - use entity name
          label = `${defendant?.defendantType_name} - ${defendant?.entity_name || "Entity"}`;
        } else {
          label = `${defendant?.defendantType_name} - ${defendant?.entity_name || "Entity"}`;
        }

        tabs.push({
          id: `defendant_${defendant?.id}`,
          label: label,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`defendant_${defendant?.id}`),
          leftHand: false,
        });
      });
    }

    return tabs;
  }, [hasAnyDefendants, defendants, handlePageChange]);

  // Button tabs: Summary, Detail, Expert (+)

  const isMediaPage = currentPage === "docs" || currentPage === "photo";
  const activeViewType = isMediaPage ? null : viewType;

  const viewTabs = useMemo(() => {
    const tabs = [];

    if (hasAnyDefendants && !isDummy) {
      tabs.push(
        {
          id: "summary",
          label: "Summary",
          className:
            activeViewType === "summary"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "summary" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => handleViewChange("summary"),
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center text-gold"
            >
              <img
                src={DatesIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        },
        {
          id: "simple",
          label: "Simple",
          className:
            activeViewType === "simple"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "simple" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => handleViewChange("simple"),
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center text-gold"
            >
              <img
                src={SimpleIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        },

        {
          id: "detailed",
          label: "Detail",
          className:
            activeViewType === "detailed"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "detailed" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => handleViewChange("detailed"),
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center text-gold"
            >
              <img
                src={DetailIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        },
        {
          id: "expanded",
          label: "Expanded",
          className:
            activeViewType === "expanded"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "expanded" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => handleViewChange("expanded"),
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center text-gold"
            >
              <img
                src={expandedIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        }
      );
    }

    return tabs;
  }, [hasAnyDefendants, isDummy, activeViewType, handleViewChange]);

  const buttonTabs = useMemo(() => {
    const tabs = [];

    // Expert add button with gold icon
    tabs.push({
      id: "defendant-add",
      label: "Defendant",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => setShow(true),
      leftHand: true,
      span: (
        <span className="fw-bold  ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, [hasAnyDefendants, viewType]);

  // Photos tab, plus a Docs tab on the detail view (replaces the Doc Row "Save to Page" button)
  const photoTabs = useMemo(() => {
    const tabs = [
      {
        id: "docs",
        label: "Docs",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        left: "0px",
        activeColor: "white",
        onClick: () => handlePageChange("docs"),
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img
              className="d-flex align-items-center justify-content-center"
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/documents-icon-color_b6TvcB7.svg"
              }
            />
          </span>
        ),
      },
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ];

    return tabs;
  }, [viewType]);
  const attachmentTabs = usePageAttachmentTabs(4, photoTabs);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  // const adjustReportColumnWidths = () => {
  //   const pinColumn = (selector) => {
  //     const cols = document.querySelectorAll(selector);
  //     if (!cols.length) return;

  //     let maxWidth = 0;
  //     cols.forEach((col) => {
  //       maxWidth = Math.max(maxWidth, col.getBoundingClientRect().width);
  //     });
  //     cols.forEach((col) => {
  //       col.style.width = `${maxWidth}px`;
  //       col.style.minWidth = `${maxWidth}px`;
  //     });
  //   };

  //   pinColumn(".defendant-name-def");
  //   pinColumn(".responsible-def");
  //   pinColumn(".insurance-def");
  //   pinColumn(".claim-def");
  //   pinColumn(".adjuster-def");
  //   pinColumn(".served-def");
  //   pinColumn(".counsel-def");
  // };

  // useEffect(() => {
  //   adjustReportColumnWidths();
  //   window.addEventListener("resize", adjustReportColumnWidths);
  //   return () => window.removeEventListener("resize", adjustReportColumnWidths);
  // }, [defendants, viewType]);
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="4" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container defendant-page">
            <div className="defendant-page__tabs">
              <SmartResponsiveTabsContainer
                isEmpty={isDummy || defendants?.length === 0}
                HandlePage={currentPage}
                tabsData={mainTabs}
                viewTab={viewTabs}
                viewTabControlled={true}
                addTab={buttonTabs}
                photoTab={attachmentTabs}
                photoTabControlled={true}
                handlePageChange={handlePageChange}
                viewType={activeViewType}
              />
            </div>
            <div className="defendant-page__content invisible-scrollbar">
              {isDummy && !isMediaPage ? (
                <>
                  <PlaceHolderifNothingAdded
                    text1={"No Defendant on the Case"}
                    text2={"Page is Marked Complete"}
                    text3={"To Add a Defendant to the Case Click Here"}
                    pageIcon={pageObject?.page_icon}
                    completed
                    onClick={() => setShow(true)}
                  />
                </>
              ) : defendants?.length === 0 && !isMediaPage ? (
                <>
                  <PlaceHolderifNothingAdded
                    text1={"No Defendants added to the Case"}
                    text2={"Click to Add"}
                    pageIcon={pageObject?.page_icon}
                    onClick={() => setShow(true)}
                  />
                </>
              ) : (
                <PageContent
                  currentPage={currentPage}
                  defendants={defendants}
                  viewType={viewType}
                  handleFetchDefendants={handleFetchDefendants}
                  setIsFetchDefendants={setIsFetchDefendants}
                  isFetchDefendants={isFetchDefendants}
                  defendantsLength={defendantsLength}
                  medicalBillData={medicalBillData}
                  pageName={pageObject?.name}
                  pageIcon={pageObject?.page_icon}
                />
              )}

              <NotesSectionDashboard pageName={"Defendant"} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {show && (
        <AddDefendantModal
          show={show}
          handleClose={handleCloseAddModal}
          refetchDef={() => handleFetchDefendants()}
          isDummy={isDummy}
        />
      )}
    </>
  );
}

export default DefendantPage;
